import styled from "styled-components";

import { StyledWithPatientNavbar } from "@layouts/WithPatientNavbar/WithPatientNavbar.styled";


export const StyledWithDashboardNavbar = styled(StyledWithPatientNavbar)`
  .nav-links-item {
    &.disabled {
      color: var(--mantine-color-gray-5);
      pointer-events: none;
      cursor: not-allowed;
    }
  }
`;
